﻿import { Directive } from "@fiqas/angular-utils";
import { FIQAssist } from "../app";

@Directive({
    module: FIQAssist,
    selector: ValidateMaxDate.selector
})
export class ValidateMaxDate implements ng.IDirective {
    public static selector = "validateMaxDate";
    public require = "ngModel";

    constructor() {

    }

    public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController): void {
        var maxDate: Date = null;
        scope.$watch<Date>(attrs[ValidateMaxDate.selector], val => {
            maxDate = val;
        });
        ctrl.$validators["maxDate"] = (modelValue: Date, viewValue: Date) => {
            if (!maxDate || ctrl.$isEmpty(modelValue))
                return true;

            var valid = modelValue.getTime() <= maxDate.getTime();
            return valid;
        };
    }
}
@Directive({
    module: FIQAssist,
    selector: ValidateMinDate.selector,
})
export class ValidateMinDate implements ng.IDirective {
    public static selector = "validateMinDate";
    public require = "ngModel";

    constructor() {

    }

    public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, ctrl: ng.INgModelController): void {
        var minDate: Date = null;
        scope.$watch<Date>(attrs[ValidateMinDate.selector], val => {
            minDate = val;
        });
        ctrl.$validators["minDate"] = (modelValue: Date, viewValue: Date) => {
            if (!minDate || ctrl.$isEmpty(modelValue))
                return true;

            var valid = minDate.getTime() <= modelValue.getTime();
            return valid;
        };
    }
} 